import SearchField from '@components/common/SearchField';
import { useTranslation } from 'react-i18next';

type SearchDebitNotesProps = {
  searchTerm: string;
  setSearchTerm: (arg0: string) => void;
};

function SearchDebitNotes(props: SearchDebitNotesProps) {
  const { t } = useTranslation('debitNote');
  const { searchTerm, setSearchTerm } = props;

  return (
    <div
      style={{ display: 'flex', marginTop: '32px', justifyContent: 'space-between', width: '100%' }}
    >
      <SearchField
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        placeholder={t('filter.by.branch.or.account.code') as string}
      />
    </div>
  );
}

export default SearchDebitNotes;
